
import SinAuth from "../templates/SinAuth";


import "primereact/resources/primereact.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "prismjs/themes/prism-coy.css";
import "../assets/demo/flags/flags.css";
import "../assets/demo/Demos.scss";
import "../assets/layout/layout.scss";
import "../App.scss";
import React from 'react';
import BlocksReciboPago from "../components/BlocksReciboPago";
//import Template from "../templates/Template";

//import { configSubdomain, useAuthDispatch, logout, useAuthState } from '../context';


const ReciboPago = (props) => {
        console.log("ReciboPago.js");

        //const dispatch = useAuthDispatch();
        //const userDetails = useAuthState();

        //const { subdomain, userName, idSuscripcion, idEmpresa, idioma } = userDetails;
          
    return (
        <SinAuth>
            <BlocksReciboPago />
        </SinAuth>
    );
};

export default ReciboPago;
